import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { getCleanedUrlParams, showError } from '@utils';
import { FILTER_RULE_ENUMS, LIMIT } from '@constants';
import { QUERY_KEYS } from 'constants/queryKeys';
import { teamsServices } from '@services';
import { useAssignees } from 'hooks/common';
import { getTeamsQueryParams, normalizeAgents, normalizeTeams } from './utils';

export const TEAMS_PAGE_SIZE = LIMIT;

export const useTeamsOperations = () => {
  const {
    assignees,
    isLoading: isAssigneesLoading,
    isFetched: isAssigneesFetched,
  } = useAssignees();
  const router = useRouter();

  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || TEAMS_PAGE_SIZE;
  const orderBy = router.query?.orderBy;
  const order = router.query?.order || 'asc';

  const params = {
    orderBy,
    order,
    page,
    pageSize: parseInt(pageSize, 10) || TEAMS_PAGE_SIZE,
  };

  const cleanParams = getTeamsQueryParams(params);

  const teamsResponse = useQuery(
    [QUERY_KEYS.GET_TEAMS_KEY, cleanParams],
    () =>
      teamsServices.getTeams(getCleanedUrlParams(params), {
        type: FILTER_RULE_ENUMS.EmptyRuleType,
      }),
    { enabled: isAssigneesFetched, refetchOnMount: true }
  );

  const agents = normalizeAgents(assignees);
  const teams = normalizeTeams(teamsResponse?.data?.data || [], agents);

  useEffect(() => {
    if (teamsResponse.isError) {
      showError(teamsResponse?.error);
    }
  }, [teamsResponse.isError]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    page,
    pageSize: parseInt(pageSize, 10) || TEAMS_PAGE_SIZE,
    total: teamsResponse?.data?.meta?.total,
    loading: teamsResponse?.isLoading || isAssigneesLoading,
    teams,
    agents,
    hasErrors: teamsResponse?.isError,
    errorMessage: teamsResponse?.error,
    getTeams: teamsResponse.refetch,
  };
};
